import React from "react";

export function DownpaymentIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 62.32 42.31"
      width="30"
      height="30"
      {...props}
    >
      <path
        className="cls-1"
        d="m62.32,42.31H0v-26.29h62.32v26.29Zm-60.73-1.58h59.15v-23.12H1.58v23.12Z"
      />
      <polygon
        className="cls-1"
        points="36.55 10.77 36.55 0 25.77 0 25.77 10.77 18.59 10.77 31.16 25.13 43.73 10.77 36.55 10.77"
      />
    </svg>
  );
}
